// extracted by mini-css-extract-plugin
export var banner = "_sm-0";
export var settingRow = "_sm-2";
export var titleIcon = "_sm-1";